import React from 'react';
import { Star } from 'lucide-react';

export function RatingStars({ rating, count, size = 12 }) {
  return (
    <span className="inline-flex items-center gap-1 text-kelate-soft" data-testid="rating-stars">
      <Star size={size} className="fill-kelate-wood text-kelate-wood" />
      <span className="text-xs font-medium text-kelate-ink">{rating}</span>
      {count != null && <span className="text-xs">({count})</span>}
    </span>
  );
}
